import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';

import OutputText from '@ey/canvascoreservices/OutputText';
import CountDropdownColumn from '../../CountDropdownColumn';

const EntitiesColumn = ({item}) => {
	const textProps = {title: labels.noEntities};
	if (item === null)
		return (
			<OutputText body2 light {...textProps} ellipsis>
				{title}
			</OutputText>
		);

	const list = item.entities.map((i) => i.name);
	const props = {
		list: list.length === 0 ? [labels.noEntities] : list
	};

	return <CountDropdownColumn {...props} />;
};

export const config = (labels) => ({
	id: contactListColumnIds.entities,
	label: labels.columnEntities,
	propName: 'entities',
	width: 'var(--px-200)',
	sortBy: ['entities', 'name'],
	customCell: (item) => {
		const props = {item};
		return <EntitiesColumn {...props} />;
	}
});
